import axios from "axios";
import AccessTokenStore from "./AccessTokenStore";
import CommonFunctions from "./CommonFunctions";

const getHeaders = (contentType) => {
  let headers = {};
  headers["Content-Type"] = (contentType) ? contentType : "application/json";
  headers["Authorization"] = 'Bearer ' + AccessTokenStore.getToken();
  return headers;
};

/**
 * Utility method to get with config
 * @param  url
 * @param {*} parma
 * @param {*} config
 */

const HTTPGetWithConfig = (URL, config, successCallback, failureCallback, transformFunc, isConfigOverride = false) => {
  const defaultConfig = {
    headers: getHeaders()
  };
  // const requestConfig = config
  //   ? (isConfigOverride ? CommonFunctions.copy(config) : CommonFunctions.jQueryExtend(true, config, defaultConfig))
  //   : defaultConfig;
  // if (!CommonFunctions.isUndefinedOrNull(requestConfig.params)) {
  //   requestConfig.params.noCache = new Date().getTime();
  // } else {
  //   requestConfig['params'] = {
  //     noCache: new Date().getTime()
  //   };
  // }
  const requestConfig = config ? ({...defaultConfig, ...config,
                                    params: {...defaultConfig.params, ...config.params},
                                    headers: {...defaultConfig.headers, ...config.headers}
                                  }) : defaultConfig;

  axios.get(URL, requestConfig)
    .then((response) => {
      const successResponse = transformFunc ? transformFunc(response.data) : response;
      successCallback(successResponse);
    })
    .catch((error) => {
      failureCallback(error);
    });
};

/**
 * Utility method to post with config
 * @param  url
 * @param {*} parma
 * @param {*} config
 */
const HTTPPostWithConfig = (URL, params, config, successCallback, failureCallback, contentType) => {
  const _params = params || {};
  const _config = config || {};

  _config.headers = {
    ...getHeaders(contentType ? contentType : ""),
    ..._config.headers
  };

  axios.post(URL, _params, _config)
    .then((response) => {
      successCallback(response);
    })
    .catch((error) => {
      failureCallback(error);
    });
};

/**
 * Utility method to delete with config
 * @param  url
 * @param {*} parma
 * @param {*} config
 */
const HTTPDeleteWithConfig = (URL, config, successCallback, failureCallback) => {
  const _config = config || {};
  _config.headers = {
    ...getHeaders(),
    ..._config.headers
  };
  axios.delete(URL, _config)
    .then(response => {
      if (CommonFunctions.isFunction(successCallback)) {
        successCallback(response);
      }
    })
    .catch((error) => {
      if (CommonFunctions.isFunction(failureCallback)) {
        failureCallback(error);
      }
    });
};

/**
 * Utility method to call Head method
 * @param {*} URL
 */
const HTTPHead = (URL, successCallback, failureCallback) => {
  axios.head(URL, {
    params: {
      noCache: new Date().getTime()
    }
  })
    .then((response) => {
      successCallback(response);
    })
    .catch((error) => {
      failureCallback(error);
    });
};

export {
  HTTPGetWithConfig,
  HTTPPostWithConfig,
  HTTPDeleteWithConfig,
  HTTPHead
}
